import { FC } from "react";
import styles from "./AuthLayout.module.scss";

const AuthLayout: FC = ({ children }) => {
    return <main className={styles.AuthLayout}>{children}</main>;
};

export default AuthLayout;
